import React from 'react'

function ThankYouPage() {
  return (
    <div>ThankYou You submitted the form successfully</div>
  )
}

export default ThankYouPage;